import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {ArticleItemComponent} from './article-item/article-item.component';
import {ContentsRoutingModule} from './contents-routing.module';
import {ArticleService} from './services/article.service';
import { ArticleListComponent } from './article-list/article-list.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ContentsComponent } from './contents/contents.component';

@NgModule({
    imports: [
        SharedModule,
        ContentsRoutingModule
    ],
    declarations: [ArticleItemComponent, ArticleListComponent, CalendarComponent, ContentsComponent],
    providers: [ArticleService],
})
export class ContentsModule {}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/contents/contents.module.ts